import Arcade from './Arcade';

export default Arcade;
